export const CONTENT_EDITOR_WALKTHROUGH_CLICKED =
  'CONTENT_EDITOR_WALKTHROUGH_CLICKED';
export const CONTENT_EDITOR_DIAGRAM_CLICKED = 'CONTENT_EDITOR_DIAGRAM_CLICKED';
export const CONTENT_EDITOR_SKIP_GUIDE_CLICKED =
  'CONTENT_EDITOR_SKIP_GUIDE_CLICKED';
export const CONTENT_EDITOR_OVERVIEW_DISMISSED =
  'CONTENT_EDITOR_OVERVIEW_DISMISSED';
export const CONTENT_EDITOR_ADD_PAGES_CLICKED =
  'CONTENT_EDITOR_ADD_PAGES_CLICKED';
